import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getStyles, translate, checkValidity, createArray } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';

import Input from '../../../components/UI/Input/Input';
import Button from '../../../components/UI/Button/Button';
import Logo from '../../../components/Logo/Logo';
import Modal from '../../../components/UI/Modal/Modal';

import localStyles from './Login.scss';
const styles = getStyles(localStyles);

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            controls: {
                email: {
                    elementConfig: {
                        type: 'email',
                        name: 'email',
                        id: 'login-email'
                    },
                    modifiers: ['stretch'],
                    label: 'formControls.emailLong',
                    value: '',
                    validation: {
                        required: true,
                        isEmail: true
                    },
                    valid: false,
                    touched: false

                },
                password: {
                    elementConfig: {
                        type: 'password',
                        name: 'password',
                        id: 'login-password'
                    },
                    modifiers: ['stretch'],
                    label: 'formControls.password',
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: false
                }
            },
            rememberUser: false,
            formIsValid: false
        };
    }

    handleChange = (event) => {
        const updatedFormElement = {...this.state.controls[event.target.name], ...{
            value: event.target.value,
            valid: checkValidity(event.target.value, this.state.controls[event.target.name].validation),
            touched: true
        }};
        const updatedControls = {...this.state.controls, ...{
            [event.target.name]: updatedFormElement
        }};

        let formIsValid = true;
        for (let inputIdentifier in updatedControls) {
            formIsValid = updatedControls[inputIdentifier].valid && formIsValid;
        }
        this.setState({ controls: updatedControls, formIsValid: formIsValid });
    }

    handleRememberUserChange = () => {
        this.setState(prevState => ({ rememberUser: !prevState.rememberUser }));
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.formIsValid) {
            this.props.onLogin(this.state.controls.email.value, this.state.controls.password.value, this.state.rememberUser);
        }
    }

    handleCloseLoginModal = () => {
        this.props.onSetGlobalState('isLoginOpen', false);
    }

    handleResetPasswordRedirect = () => {
        this.handleCloseLoginModal();

        this.props.history.push({ pathname: '/reset-password' });
    }

    handleOpenSignup = () => {
        this.handleCloseLoginModal();
        this.props.onSetGlobalState('isSignupOpen', true);
    }

    render() {
        const formElementsArray = createArray(this.state.controls);
        const errorMessage = this.props.userError ? <div className={styles('login__error', 'c--error')}><p>{this.props.userError}</p></div> : null;

        const form = (
            <form className={styles('login__form')} onSubmit={this.handleSubmit}>
                {formElementsArray.map(element => (
                    <Input
                        key={element.id}
                        attrs={element.config.elementConfig}
                        value={element.config.value}

                        modifiers={element.config.modifiers}

                        invalid={!element.config.valid}
                        touched={element.config.touched}

                        required={element.config.validation.required}

                        events={{ change: this.handleChange }}

                        label={translate(element.config.label, this.props.language)}
                        loading={this.props.userLoading}
                    />
                ))}
                <Input
                    attrs={{ type: 'checkbox' }}
                    labelClasses={styles('flex', 'sidepanel__remember__label')}
                    checked={this.state.rememberUser}
                    events={{ change: this.handleRememberUserChange }}
                    disabled={this.props.userLoading}
                >
                    <p className={styles('c--text-light')}>
                        {translate('pages.login.rememberUser', this.props.language)}
                    </p>
                </Input>
                <Button
                    attrs={{ type: 'submit' }}
                    modifiers={['primary', 'stretch', 'm', 'spaced']}
                    disabled={!this.state.formIsValid}
                    loading={this.props.userLoading}
                >
                    {translate('pages.login.button', this.props.language)}
                </Button>
            </form>
        );

        const modalContent = (
            <div className={styles('login')}>
                {errorMessage}
                {form}

                <div className={styles('flex', 'flex--wrap', 'login__footer')}>

                    <div className={styles('col--100 col__xxs--50')}>
                        <h6>{translate('pages.login.forgotPasswordTitle', this.props.language)}</h6>
                        <p>
                            <Button
                                modifiers={['text']}
                                classes={styles('c--text-light', 'underline')}
                                events={{ click: this.handleResetPasswordRedirect }}
                                disabled={this.props.userLoading}
                            >{translate('pages.login.forgotPasswordLink', this.props.language)}</Button>
                        </p>
                    </div>


                    <div className={styles('col--100 col__xxs--50')}>
                        <h6>{translate('pages.login.signupTitle', this.props.language)}</h6>
                        <p>
                            <Button
                                modifiers={['text']}
                                classes={styles('c--text-light', 'underline')}
                                events={{ click: this.handleOpenSignup }}
                                disabled={this.props.userLoading}
                            >{translate('pages.login.signupLink', this.props.language)}</Button>
                        </p>
                    </div>

                    <div className={styles('align--center', 'col--100', 'login__footer__logo')}>
                        <p className={styles('small c--text-lightest')}>
                            {translate('pages.login.poweredBy', this.props.language)} <Logo modifiers={['inline']} />
                        </p>
                    </div>

                </div>
            </div>
        );

        return this.props.isLoginOpen ? (
            <Modal
                isOpen={this.props.isLoginOpen}
                title={translate('pages.login.title', this.props.language)}
                noClosing={this.props.userLoading}
                close={this.handleCloseLoginModal}
            >
                {modalContent}
            </Modal>
        ) : null;
    }
}

Login.propTypes = {
    // properties
    history: PropTypes.object.isRequired,
    isAuthorized: PropTypes.bool.isRequired,
    isLoginOpen: PropTypes.bool.isRequired,
    
    userLoading: PropTypes.bool,
    userError: PropTypes.string,

    language: PropTypes.string.isRequired,

    // functions
    onLogin: PropTypes.func.isRequired,
    onSetGlobalState: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        isAuthorized: !!state.details.user.data,
        isLoginOpen: state.global.isLoginOpen,

        userLoading: state.details.user.loading,
        userError: state.details.user.error,

        language: state.global.localization.language

    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLogin: (email, password, remember) => dispatch(actions.login(email, password, remember)),
        onSetGlobalState: (identifier, value) => dispatch(actions.setGlobalState(identifier, value))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/containers/User/Login/Login.js